module.exports = __webpack_public_path__ + "img/lose_lottery0_small.4986608e.png";